import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { BASE_URL } from "../config";
import axios from 'axios';
import authStorage from "../utils/authStorage";
import moment from "moment";
import ContentModal from "../components/contentModal";

const CompanySignUp = () => {
    const params = useParams();

    const [customerForm, setCustomerForm] = useState({
        companyName: "",
        personInCharge: "",
        email: "",
        typeOfCompany: "",
        dob: "",
        gender: "",
        height: "",
        weight: "",
        medicalConsent: false,
        termsAccepted: false
    });
    const [consentContent, setConsentContent] = useState({ title: "", content: "" });
    const [showConsentModal, setShowConsentModal] = useState(false);
    const [showInvalidLink, setShowInvalidLink] = useState(false);
    const [loading, setLoading] = useState('');
    const [submitLoading, setSubmitLoading] = useState('');
    const [error, setError] = useState('');
    const [passwordError, setPasswordError] = useState('Password should not be empty');
    const [confirmPasswordError, setConfirmPasswordError] = useState('Confirm password should not be empty');
    const [formTouched, setFormTouched] = useState(false);
    const [employeeRangeError, setEmployeeRangeError] = useState('Employee range is required');
    const isEmployeeRangeValid = !!customerForm?.employeeRange;
    const [expectedCftUserError, setExpectedCftUserError] = useState("");

    const navigate = useNavigate();
    const location = useLocation();
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;

    const handlePasswordChange = (event) => {
        const value = event.target.value;
        setCustomerForm({ ...customerForm, password: value });

        if (!passwordRegex.test(value)) {
            setPasswordError('Password must contain at least one digit, one lowercase letter, one uppercase letter, and be at least 8 characters long.');
        } else {
            setPasswordError('');
        }
    };

    const handleConfirmPasswordChange = (event) => {
        const value = event.target.value;
        setCustomerForm({ ...customerForm, confirmPassword: value });
        if (customerForm?.password !== value) {
            setConfirmPasswordError('Confirm password must match password');
        } else {
            setConfirmPasswordError('');
        }
    };

    const verifyUser = () => {
        setError("");
        setLoading(true);
        axios({
            url: `${BASE_URL}/auth/invite/company/${params?.token}`, //your url
            method: 'get'
        }).then((res) => {
            console.log('user data', res?.data?.data);
            setLoading(false);
            let userData = res?.data?.data;
            setCustomerForm(prev => ({ ...prev, companyName: userData?.companyName, personInCharge: userData?.personInCharge, email: userData?.email, typeOfCompany: userData?.typeOfCompany }))
        }).catch((err) => {
            setShowInvalidLink(true);
            if (err?.response?.data?.message) {
                setError(err?.response?.data?.message);
            }
            setLoading(false);
        });
    };

    const validateExpectedCftUser = (employeeRange, expectedCftUser) => {
        switch (employeeRange) {
            case "small":
                if (expectedCftUser < 1 || expectedCftUser > 9999) return "Expected CFT User should be between 1 and 9999 for small companies.";
                break;
            case "medium":
                if (expectedCftUser < 10000 || expectedCftUser > 99999) return "Expected CFT User should be between 10,000 and 99,999 for medium companies.";
                break;
            case "big":
                if (expectedCftUser < 100000) return "Expected CFT User should be 100,000 or more for large companies.";
                break;
            default:
                return "Please select a valid employee range.";
        }
        return null;
    };


    const handleLoginSubmit = (event) => {
        setFormTouched(true);

        if (!customerForm?.employeeRange) {
            setEmployeeRangeError('Employee range is required');
        } else {
            setEmployeeRangeError('');
        }

        const validationError = validateExpectedCftUser(customerForm.employeeRange, customerForm.expectedCftUser);
        if (validationError) {
            setExpectedCftUserError(validationError);
            return;
        } else {
            setExpectedCftUserError('');
        }

        
        if (!isEmployeeRangeValid || passwordError || confirmPasswordError || !customerForm?.companyName || !customerForm?.personInCharge || !customerForm?.typeOfCompany || employeeRangeError) {
            return;
        };
        if (!customerForm?.dob || !customerForm?.gender || !customerForm?.height || !customerForm?.weight) {
            setError("Please fill in date of birth, sex, height and weight.");
            setTimeout(() => setError(""), 4000);
            return;
        }
        if (moment().diff(moment(customerForm.dob), 'years') < 18) {
            setError("You must be 18 years or older to register.");
            setTimeout(() => setError(""), 4000);
            return;
        }
        if (!customerForm?.medicalConsent) {
            setError("Please confirm the medical consent to continue.");
            setTimeout(() => setError(""), 4000);
            return;
        }
        if (!customerForm?.termsAccepted) {
            setError("Please accept the Terms and Conditions to continue.");
            setTimeout(() => setError(""), 4000);
            return;
        }
        setError("");
        setSubmitLoading(true);
        axios({
            url: `${BASE_URL}/auth/add/company`, //your url
            method: 'POST',
            data: customerForm
        }).then((res) => {
            setSubmitLoading(false);
            setTimeout(() => {
                navigate('/');
            }, 200);
        }).catch((err) => {
            if (err?.response?.data?.message) {
                setError(err?.response?.data?.message);
                setTimeout(() => {
                    setError("");
                }, 3000);
            }
            setSubmitLoading(false);
        });
    };

    useEffect(() => {
        verifyUser();
    }, []);

    // Load the editable medical-condition disclaimer shown in the "Read more" popup.
    useEffect(() => {
        axios.get(`${BASE_URL}/content/medicalConsent`)
            .then((res) => {
                if (res?.data?.data) {
                    setConsentContent({ title: res.data.data.title, content: res.data.data.content });
                }
            })
            .catch((err) => console.log("Failed to load consent content", err));
    }, []);

    return (
        <>
             <ContentModal
                show={showConsentModal}
                onClose={() => setShowConsentModal(false)}
                title={consentContent.title || "Health & Medical Disclaimer"}
                content={consentContent.content}
             />
             <div className="bg-[#F9F9F9] h-screen">

<div className="justify-center m-8 p-4 md:p-6 bg-white rounded-lg flex items-center justify-center" >
                    {loading && (
                         <div role="status">
                         <svg aria-hidden="true" class="w-24 h-24 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                             <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                             <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                         </svg>
                         <span class="sr-only">Loading...</span>
                     </div>
                    )}
                    {!loading && <> {showInvalidLink ? (
                        <p className="text-red-500">Invalid Link</p>
                    ) : (
                        <div className="w-full max-w-xl bg-white p-4 mt-1">
                            <div className="flex justify-center">
                                <img className='w-80' src={require('../assets/logo-lg.png')} alt="logo" />
                            </div>
                            <div className="text-center text-lg font-semibold text-gray-800">Company Sign Up</div>
                            <div className="flex items-center justify-center py-2">
                                <form style={{ zIndex: '80000' }} className="md:w-[40vw] w-[80vw]" action="#" method="POST">
                                    <input type="hidden" name="remember" value="true" />
                                    <div className="rounded-md">
                                        <div className="my-1">
                                            <label htmlFor="companyName" className="sr-only">Company Name</label>
                                            <input
                                                value={customerForm?.companyName}
                                                onChange={(e) => setCustomerForm({ ...customerForm, companyName: e.target.value })}
                                                id="companyName"
                                                name="companyName"
                                                type="text"
                                                className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                placeholder="Company Name"
                                            />
                                        </div>
                                        <div className="my-2">
                                            <label htmlFor="personInCharge" className="sr-only">Name of the person in charge</label>
                                            <input
                                                value={customerForm?.personInCharge}
                                                onChange={(e) => setCustomerForm({ ...customerForm, personInCharge: e.target.value })}
                                                id="personInCharge"
                                                name="personInCharge"
                                                type="text"
                                                className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                placeholder="Name of the person in charge"
                                            />
                                        </div>
                                        <div className="my-2">
                                            <label htmlFor="email-address" className="sr-only">Email</label>
                                            <input
                                                value={customerForm?.email}
                                                onChange={(e) => setCustomerForm({ ...customerForm, email: e.target.value })}
                                                id="email-address"
                                                name="email"
                                                type="email"
                                                disabled
                                                required
                                                className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                placeholder="Email"
                                            />
                                        </div>
                                        <div className="my-2">
                                            <label htmlFor="typeOfCompany" className="sr-only">Type of company</label>
                                            <input
                                                value={customerForm?.typeOfCompany}
                                                onChange={(e) => setCustomerForm({ ...customerForm, typeOfCompany: e.target.value })}
                                                id="typeOfCompany"
                                                type="text"
                                                required
                                                className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                placeholder="Type of company"
                                            />
                                        </div>
                                        <div className="text-center mb-2 text-gray-800 mt-5">No Of Employee</div>
                                        <ul class="text-sm font-medium text-center text-gray-800 border border-gray-400 divide-x divide-gray-400 shadow sm:flex dark:divide-gray-700 dark:text-gray-800">
                                            <span class="w-full">
                                                <span
                                                    onClick={() => setCustomerForm({
                                                        ...customerForm,
                                                        employeeRange: "small",
                                                    })}
                                                    className={`cursor-pointer ${(customerForm?.employeeRange === "small") && 'bg-[#2995F7] text-white'} inline-block w-full p-4 dark:bg-gray-700 dark:text-white`}
                                                >
                                                    1-9999
                                                </span>
                                            </span>
                                            <span class="w-full">
                                                <span
                                                    onClick={() => setCustomerForm({
                                                        ...customerForm,
                                                        employeeRange: "medium",
                                                    })}
                                                    className={`cursor-pointer ${(customerForm?.employeeRange === "medium") && 'bg-[#2995F7] text-white'} inline-block w-full p-4 dark:bg-gray-800 dark:hover:bg-gray-700`}
                                                >
                                                    10k-99999
                                                </span>
                                            </span>
                                            <span class="w-full">
                                                <span
                                                    onClick={() => setCustomerForm({
                                                        ...customerForm,
                                                        employeeRange: "big",
                                                    })}
                                                    className={`cursor-pointer ${(customerForm?.employeeRange === "big") && 'bg-[#2995F7] text-white'} inline-block w-full p-4 dark:bg-gray-800 dark:hover:bg-gray-700`}
                                                >
                                                    Above 100k
                                                </span>
                                            </span>
                                        </ul>
                                        {formTouched && <span className="text-red-500">{employeeRangeError}</span>}
                                        <div className="my-2">
                                            <label htmlFor="expectedCftUser" className="sr-only">Expected CFT User</label>
                                            <input
                                                value={customerForm?.expectedCftUser}
                                                onChange={(e) => setCustomerForm({ ...customerForm, expectedCftUser: e.target.value })}
                                                id="expectedCftUser"
                                                type="number"
                                                required
                                                className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                placeholder="Expected CFT User"
                                            />
                                            {formTouched && <span className="text-red-500">{expectedCftUserError}</span>}
                                        </div>
                                        <div className="my-2">
                                            <label htmlFor="password" className="sr-only">Password</label>
                                            <input
                                                value={customerForm?.password}
                                                onChange={(e) => handlePasswordChange(e)}
                                                id="password"
                                                type="password"
                                                required
                                                className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                placeholder="Confirm Password"
                                                autoComplete="new-password"
                                            />
                                            {formTouched && <span className="text-red-500">{passwordError}</span>}
                                        </div>
                                        <div className="my-2">
                                            <label htmlFor="passwordConfirm" className="sr-only">Confirm Password</label>
                                            <input
                                                value={customerForm?.confirmPassword}
                                                onChange={(e) => handleConfirmPasswordChange(e)}
                                                id="passwordConfirm"
                                                name="passwordConfirm"
                                                type="password"
                                                required
                                                className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                placeholder="Confirm Password"
                                                autoComplete="new-password"
                                            />
                                            {formTouched && <span className="text-red-500">{confirmPasswordError}</span>}
                                        </div>
                                        <div className="my-2">
                                            <label htmlFor="dob" className="block text-sm text-gray-800 mb-1">Date of Birth<span className="text-red-500"> *</span></label>
                                            <input
                                                value={customerForm?.dob || ""}
                                                onChange={(e) => setCustomerForm({ ...customerForm, dob: e.target.value })}
                                                id="dob"
                                                name="dob"
                                                type="date"
                                                max={moment().subtract(18, 'years').format('YYYY-MM-DD')}
                                                min={moment().subtract(100, 'years').format('YYYY-MM-DD')}
                                                className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                            />
                                            {formTouched && !customerForm?.dob && <span className="text-red-500">Date of birth is required</span>}
                                        </div>
                                        <div className="my-2">
                                            <label htmlFor="gender" className="block text-sm text-gray-800 mb-1">Sex<span className="text-red-500"> *</span></label>
                                            <select
                                                value={customerForm?.gender || ""}
                                                onChange={(e) => setCustomerForm({ ...customerForm, gender: e.target.value })}
                                                id="gender"
                                                name="gender"
                                                className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                            >
                                                <option value="">Select Sex</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                                <option value="other">Other</option>
                                            </select>
                                            {formTouched && !customerForm?.gender && <span className="text-red-500">Sex is required</span>}
                                        </div>
                                        <div className="my-2 flex gap-2">
                                            <div className="w-full">
                                                <label htmlFor="height" className="block text-sm text-gray-800 mb-1">Height (cm)<span className="text-red-500"> *</span></label>
                                                <input
                                                    value={customerForm?.height || ""}
                                                    onChange={(e) => setCustomerForm({ ...customerForm, height: e.target.value })}
                                                    id="height"
                                                    name="height"
                                                    type="number"
                                                    min="0"
                                                    placeholder="Height in cm"
                                                    className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                />
                                                {formTouched && !customerForm?.height && <span className="text-red-500">Height is required</span>}
                                            </div>
                                            <div className="w-full">
                                                <label htmlFor="weight" className="block text-sm text-gray-800 mb-1">Weight (kg)<span className="text-red-500"> *</span></label>
                                                <input
                                                    value={customerForm?.weight || ""}
                                                    onChange={(e) => setCustomerForm({ ...customerForm, weight: e.target.value })}
                                                    id="weight"
                                                    name="weight"
                                                    type="number"
                                                    min="0"
                                                    placeholder="Weight in kg"
                                                    className="bg-theme-blue autofill:bg-slate-800 relative block w-full appearance-none border border-[#2d3d5c] px-3 py-2 text-gray-900 placeholder-gray-600 focus:z-10 focus:border-gray-400 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                />
                                                {formTouched && !customerForm?.weight && <span className="text-red-500">Weight is required</span>}
                                            </div>
                                        </div>
                                        <div className="my-2">
                                            <label htmlFor="medicalConsent" className="cursor-pointer flex items-start gap-2 text-sm text-gray-800">
                                                <input
                                                    className="mt-1"
                                                    type="checkbox"
                                                    checked={customerForm?.medicalConsent || false}
                                                    onChange={(e) => setCustomerForm({ ...customerForm, medicalConsent: e.target.checked })}
                                                />
                                                <span>
                                                    I confirm that if I have any medical condition (such as a heart condition, high blood pressure, diabetes, etc.), I have consulted my physician before participating.<span className="text-red-500"> *</span>{" "}
                                                    <span
                                                        className="font-medium text-blue-600 underline cursor-pointer"
                                                        onClick={(e) => { e.preventDefault(); setShowConsentModal(true); }}
                                                    >
                                                        Read more
                                                    </span>
                                                </span>
                                            </label>
                                            {formTouched && !customerForm?.medicalConsent && <span className="text-red-500">Please confirm the medical consent</span>}
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="mx-4 my-2">
                                <label htmlFor="termsAccepted" className="cursor-pointer flex items-start gap-2 text-sm text-gray-800">
                                    <input
                                        className="mt-1"
                                        type="checkbox"
                                        checked={customerForm?.termsAccepted || false}
                                        onChange={(e) => setCustomerForm({ ...customerForm, termsAccepted: e.target.checked })}
                                    />
                                    <span>
                                        I have read and agree to the
                                        <a href="https://beta.contingentfitness.com/terms-and-conditions/" className="font-medium text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer"> Terms and Conditions</a> and
                                        <a href="https://beta.contingentfitness.com/privacy-policy/" className="font-medium text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer"> Privacy Policy</a>.<span className="text-red-500"> *</span>
                                    </span>
                                </label>
                                {formTouched && !customerForm?.termsAccepted && <span className="text-red-500 block">Please accept the Terms and Conditions</span>}
                            </div>
                            <div className="text-red-500 pt-2 text-center h-8">{error}</div>
                            <div className="flex justify-center">
                                <button onClick={() => handleLoginSubmit()} type="button" className="group relative flex w-40 justify-center rounded-md border border-transparent bg-[#4285F4] py-2 px-4 text-sm font-medium text-white hover:bg-[#4285F4] focus:outline-none">
                                    {loading ? (<div className="lds-facebook"><div></div><div></div><div></div><div></div><div></div></div>) : "Register"}
                                </button>
                            </div>
                        </div>
                    )}
                    </>
                    }
                </div >
            </div >
        </>
    )
}
export default CompanySignUp;